<template>
  <b-container>
    <ProfileHero :artist="artist" />
    <ArtistProfileTabs :artist="artist" />

    <b-row>
      <b-col>
        <b-form-group label="Send Message">
          <b-form-textarea :rows="5" :max-rows="10" required v-model="message"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="isArtist">
        <b-form-group horizontal label="Send as">
          <b-form-select v-model="sendAsArtist" id="visibility" :options="sendOptions" />
        </b-form-group>
      </b-col>
      <b-col class="text-right">
        <b-button class="btn-rainbow" @click="send" :disabled="!message">Send</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  img.avatar {  }
</style>

<script>
import { mapGetters } from 'vuex'

import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'

export default {
  name: 'SendMessage',
  components: {
    ArtistProfileTabs,
    ProfileHero
  },
  data () {
    return {
      artist: {},
      message: '',
      sendAsArtist: false
    }
  },
  computed: {
    sendOptions () {
      return [
        { value: false, text: 'Fan (@' + this.currentUser.username + ')' },
        { value: true, text: 'Artist (@' + this.$store.getters['artist/artist'].handle + ')' }
      ]
    },
    ...mapGetters('profile', ['currentUser', 'isArtist'])
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      if (this.currentArtist && this.$route.params.artistId === this.currentArtist.id) {
        this.$router.push({name: 'artist-messages'})
        return
      }

      this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
    },
    async send () {
      await this.$store.dispatch('profile/sendMessage', {
        peerId: this.artist.inbox,
        text: this.message,
        sendAsArtist: this.sendAsArtist
      })
      this.$store.dispatch('flash/showMessage', {message: 'Message sent'})
      this.$router.push({name: 'fan-messages'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/SendMessage.vue